// extracted by mini-css-extract-plugin
export var carrierTab = "_44-0";
export var carrierTabActive = "_44-1 _44-0";
export var carrierTabInactive = "_44-2 _44-0";
export var carrierTabLabel = "_44-3";
export var carrierTabLabelActive = "_44-4 _44-3";
export var carrierTabLabelInactive = "_44-5 _44-3";
export var carrierTabPercentage = "_44-6";
export var carrierTabPercentageActive = "_44-7 _44-6";
export var carrierTabPercentageInactive = "_44-8 _44-6";
export var carrierTabWinnable = "_44-9";
export var carrierTabWinnableActive = "_44-a _44-9";
export var carrierTabWinnableInactive = "_44-b _44-9";
export var comparisonContainer = "_44-d";
export var missingRateButton = "_44-n";
export var missingRateButtonActive = "_44-o _44-n";
export var missingRateButtonInactive = "_44-p _44-n";
export var missingRateButtonLabel = "_44-q";
export var missingRateButtonLabelActive = "_44-r _44-q";
export var missingRateButtonLabelInactive = "_44-s _44-q";
export var sidebar = "_44-c";
export var strategyButton = "_44-e";
export var strategyButtonActive = "_44-f _44-e";
export var strategyButtonDescription = "_44-k";
export var strategyButtonDescriptionActive = "_44-l _44-k";
export var strategyButtonDescriptionInactive = "_44-m _44-k";
export var strategyButtonInactive = "_44-g _44-e";
export var strategyButtonLabel = "_44-h";
export var strategyButtonLabelActive = "_44-i _44-h";
export var strategyButtonLabelInactive = "_44-j _44-h";
export var unitToggleButton = "_44-t";
export var unitToggleButtonActive = "_44-u _44-t";
export var unitToggleButtonInactive = "_44-v _44-t";
export var unitToggleButtonLabel = "_44-w";
export var unitToggleButtonLabelActive = "_44-x _44-w";
export var unitToggleButtonLabelInactive = "_44-y _44-w";